<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>订单管理</el-breadcrumb-item> -->
      <el-breadcrumb-item>订单处理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
          <el-form
              :inline="false"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-row :gutter="24">
                <el-col :span="7">
                  <el-form-item label="保险公司" size="small">
                      <el-select
                        clearable
                        v-model="searchForm.corp_name"
                        placeholder="请选择保司"
                        @change="changeCorpValue($event)"
                      >
                        <el-option v-for="item in CorpData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="保险公司" size="small">
                    <el-input placeholder="请输入保险公司" v-model="searchForm.corpName" type="text"></el-input>
                  </el-form-item> -->
                </el-col>
                <el-col :span="7">
                  <el-form-item label="日期" size="small">
                    <el-date-picker clearable type="date" placeholder="选择日期" v-model="searchForm.effective_date" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="车架号" size="small">
                    <el-input clearable placeholder="请输入车辆识别代号" v-model="searchForm.vin" type="text"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="7">
                  <el-form-item label="投保人" size="small">
                      <el-select
                        clearable
                        v-model="searchForm.ship_name"
                        placeholder="请选择投保人"
                        @change="changeShipCompanyValue($event)"
                      >
                        <el-option v-for="item in ShipData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                  </el-form-item>

                  <!-- <el-form-item label="投保人" size="small">
                    <el-input placeholder="请选择投保人" v-model="searchForm.owner_name" type="text"></el-input>
                  </el-form-item> -->
                </el-col>
                <el-col :span="7">
                  <el-form-item label="被投保人" size="small">
                      <el-select
                        clearable
                        v-model="searchForm.owner_name"
                        placeholder="请选择被投保人"
                        @change="changeOwnerValue($event)"
                      >
                        <el-option v-for="item in OwnerData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                  </el-form-item>
<!--
                  <el-form-item label="被投保人" size="small">
                    <el-input placeholder="请输入被投保人" v-model="searchForm.allPerson" type="text"></el-input>
                  </el-form-item> -->
                </el-col>
                <el-col :span="7">
                  <el-form-item label="业务渠道" size="small">
                      <el-select
                        clearable
                        v-model="searchForm.crmMembe_name"
                        placeholder="请选择业务渠道"
                        @change="changeCrmMembeValue($event)"
                      >
                        <el-option v-for="item in CrmMembeData"
                            :key="item.id"
                            :label="item.contact_name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="业务渠道" size="small">
                    <el-input clearable placeholder="请输入渠道" v-model="searchForm.corp_channel_name" type="text"></el-input>
                  </el-form-item> -->
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="7">
                  <el-form-item label="产品方案" size="small">
                      <el-select
                        clearable
                        v-model="searchForm.product_name"
                        placeholder="请选择产品方案"
                        @change="changeProductValue($event)"
                      >
                        <el-option v-for="item in ProductData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="产品方案" size="small">
                    <el-input clearable placeholder="请选择产品方案" v-model="searchForm.product_name" type="text"></el-input>
                  </el-form-item> -->
                </el-col>
                <el-col :span="7">
                  <el-form-item label="车牌号" size="small">
                    <el-input clearable placeholder="请输入车牌号" v-model="searchForm.plate_number" type="text"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="订单状态" size="small">
                    <el-select
                      v-model="searchForm.status" clearable
                      placeholder="请选择状态"
                    >
                      <el-option label="待审核" :value="0"></el-option>
                      <el-option label="已审核" :value="1"></el-option>
                      <el-option label="已出单" :value="2"></el-option>
                      <el-option label="已完成" :value="3"></el-option>
                      <el-option label="取保" :value="4"></el-option>
                      <el-option label="退单" :value="5"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
                </el-col>
            </el-row>
          </el-form>
      </el-row>
        <!-- <el-button @click="searchRest()">重置</el-button> -->
        <!-- 表格 -->
      <div style="margin: 20px 0;">
        <el-button type="primary" size="small" @click="clickDialog()">合并支付凭证</el-button>
        <el-button size="small">已选数量{{ this.clickPayNum }}</el-button>
        <el-button size="small">共计金额{{this.sumTotal}}</el-button>
      </div>
      <el-table
          ref="multipleTable"
          :data="orderData"
          height="450"
          border
          :header-cell-style="headStyle"
          @selection-change="handleSelectionChange"
          >
        <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
        <el-table-column
          label="签单日期"
          width="105"
          :show-overflow-tooltip='true'
          >
          <template slot-scope="scope">{{ scope.row.effective_date | dateFormat }}</template>
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="保险起期"
          width="105"
          :show-overflow-tooltip='true'
          >
          <template slot-scope="scope">{{ scope.row.start_time | dateFormat }}</template>
        </el-table-column>
        <el-table-column
          prop="corp_name"
          label="保险公司"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="product_md_title"
          label="险种方案标题"
          width="130"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="product_name"
          label="险种"
          width="80"
          >
        </el-table-column>
        <el-table-column
          prop="proposal_form"
          label="保险单号"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="policy_no"
          label="投保单号"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          label="电子保单"
          :show-overflow-tooltip='true'
          >
          <template slot-scope="scope">
            <span v-if="scope.row.policy_no_pdf_url == null">暂无</span>
            <a v-else :href="scope.row.policy_no_pdf_url.local_file_path">{{ scope.row.policy_no_pdf_url.local_file_path }}</a>
            <!-- <img>{{ scope.row.policy_no_pdf_url==null?"暂无":scope.row.policy_no_pdf_url.local_file_path }} -->
          </template>
        </el-table-column>
        <el-table-column
          label="电子发票"
          :show-overflow-tooltip='true'
          >
          <template slot-scope="scope">
            <span v-if="scope.row.invoice_pdf_url == null">暂无</span>
            <a v-else :href="scope.row.invoice_pdf_url.local_file_path">{{ scope.row.invoice_pdf_url.local_file_path }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="owner_name"
          label="投保人"
          width="100"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="allPerson"
          label="被保险人"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="plate_number"
          label="号码号牌"
          width="105"
          >
        </el-table-column>
        <el-table-column
          prop="real_price"
          label="保费（元）"
          width="100"
          >
        </el-table-column>
        <el-table-column
          prop="corp_channel_name"
          label="出单渠道"
          :show-overflow-tooltip='true'
          >
        </el-table-column>
        <el-table-column
          prop="price"
          label="渠道净费（元）"
          width="130"
          >
        </el-table-column>
        <el-table-column
          prop="sell_price"
          label="外放净费（元）"
          width="120"
          >
        </el-table-column>
        <el-table-column
          label="盈利（元）"
          width="100"
          >
          <template slot-scope="scope">{{(scope.row.sell_price) - (scope.row.price)}}</template>
        </el-table-column>
        <el-table-column
          label="是否对公"
          >
          <template slot-scope="scope" v-if="scope.row.is_company==1">对公</template>
          <templat v-else>对私</templat>
        </el-table-column>
        <el-table-column
          prop="pay_sn"
          label="是否合并"
          width="120"
          >
        </el-table-column>
        <el-table-column
          label="转账截图"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.pay_sn_url.length">
              <img :src="scope.row.pay_sn_url[0].local_file_path" min-width="20" height="20"/>
            </span>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column
          label="费用是否结清"
          width="110"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.file_url != null">
                <el-button type="success" size="mini">是</el-button>
              </span>
              <span v-else>
                <el-button type="danger" size="mini">否</el-button>
              </span>
          </template>
        </el-table-column>
        <el-table-column
          label="欠费金额（元）"
          width="120"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.file_url == null">
                {{(scope.row.sell_price)}}
                <!-- <el-button type="success" size="mini">是</el-button> -->
              </span>
          </template>
        </el-table-column>
        <el-table-column
            label="订单状态"
            width="100"
           >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0"><el-button size="mini">{{scope.row.status | statusFilter}}</el-button></span>
              <span v-if="scope.row.status == 1"><el-button type="primary" size="mini">{{scope.row.status | statusFilter}}</el-button></span>
              <span v-if="scope.row.status == 2"><el-button type="success" size="mini">{{scope.row.status | statusFilter}}</el-button></span>
              <span v-if="scope.row.status == 3"><el-button type="info" size="mini">{{scope.row.status | statusFilter}}</el-button></span>
              <span v-if="scope.row.status == 4"><el-button type="warning" size="mini">{{scope.row.status | statusFilter}}</el-button></span>
              <span v-if="scope.row.status == 5"><el-button type="danger" size="mini">{{scope.row.status | statusFilter}}</el-button></span>
            </template>
          </el-table-column>
        <el-table-column
          prop="operator_name"
          label="操作人"
          >
        </el-table-column>
        <el-table-column
          prop="employee_name"
          label="出单人员"
          >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"

          width="180px"
          center
          >
          <template slot-scope="scope">
            <span v-if="scope.row.issuer_id > 0">
              <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            </span>
            <el-tooltip content="指定分配人出单人" placement="bottom" effect="light">
              <span v-if="scope.row.issuer_id == null">
                <el-button type="success" size="mini" icon="el-icon-folder-checked" @click="handelAppointUser(scope.row)"></el-button>
              </span>
            </el-tooltip>
            <el-tooltip content="是否出单承保" placement="bottom" effect="light" v-if="scope.row.corp_id == 33 && scope.row.issue_status == 2">
                <el-button type="primary" icon="el-icon-setting" size="mini" @click="handelUnderwritel(scope.row)"></el-button>
            </el-tooltip>
            <!-- <el-tooltip content="上传保单" placement="bottom" effect="light" v-if="(scope.row.policy_no_pdf_url == null)">
                <el-button icon="el-icon-upload" size="mini" @click="handelUploadPolicy(scope.row)"></el-button>
            </el-tooltip>    -->
            <el-tooltip content="上传电子发票" placement="bottom" effect="light" v-if="scope.row.invoice_pdf_url == null">
                <el-button type="info" icon="el-icon-folder-add" size="mini" @click="handelUploadinvoice(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:10px">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[30, 100]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
        </el-pagination>
      </div>

    </el-card>

    <el-dialog title="维护人员选择" :visible.sync="teamDialog" width="550px">
        <!-- 所属团队表格 -->
        <el-table
          stripe
          border
          height="500"
          :data="teamTableData"
          style="width: 100%">
          <el-table-column label="选择" align="center" width="65">
              <template slot-scope="scope">
                <el-radio :label="scope.$index" v-model="teamRadio" @change.native="getTeamRow(scope.row)"
              >&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="sn"
            label="工号"
            width="70">
          </el-table-column>
          <el-table-column
            label="手机号码"
            width="140">
            <template slot-scope="scope">{{ scope.row.mobile }}</template>
          </el-table-column>
          <el-table-column
            label="性别"
            width="60">
            <template slot-scope="scope">{{ scope.row.sex | sexFilter }}</template>
          </el-table-column>
          <el-table-column
            label="部门"
            >
            <template slot-scope="scope">{{ scope.row.department_name }}</template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="teamSizeChange"
                @current-change="teamCurrentChange"
                :current-page="teamPage"
                :page-sizes="[30, 100]"
                :page-size="teamLimit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="teamTotal">
          </el-pagination>
        </div>
    </el-dialog>

    <el-dialog title="合并支付凭证订单" :visible.sync="dialogUpload" width="700px" style="line-height: 0;">
      <el-form
              style="margin-top:20px"
              :inline="false"
              :model="paySnForm"
              :rules="paySnRules"
              ref="paySnRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-form-item label="图片上传">
              <div class="pay_upload" v-if="this.dialogImageUrl == ''">
                <el-upload
                    :on-change="UploadImage"
                    drag
                    :limit="1"
                    :auto-upload="false"
                    :file-list="fileUploadList"
                    :show-file-list="false"
                    action=""
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <img class="pay_img" v-else style="width: 140px;height: 80px" :src="dialogImageUrl" alt="" />
            </el-form-item>
            <el-row :gutter="24">
                <el-col :span="10">
                    <el-form-item label="是否对公" size="small">
                      <el-select
                        v-model="paySnForm.is_company"
                        placeholder="请选择"
                      >
                        <el-option label="对公" :value="1"></el-option>
                        <el-option label="净费" :value="0"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="佣金" size="small" prop="commission" label-width="80px">
                      <el-input placeholder="请输入佣金" v-model="paySnForm.commission" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="收款人" size="small" label-width="80px">
                      <el-input placeholder="请输入收款人" v-model="paySnForm.account" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="收款账号" size="small" label-width="80px">
                      <el-input placeholder="请输入收款人账号" v-model="paySnForm.account_number" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="付款人" size="small"  label-width="80px">
                      <el-input placeholder="请输入付款人" v-model="paySnForm.payee_account" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="付款账号" size="small" label-width="80px">
                      <el-input placeholder="请输入付款账号" v-model="paySnForm.payee_account_number" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="凭证金额" size="small" label-width="80px">
                      <el-input placeholder="请输入凭证金额" v-model="paySnForm.pay_money" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="支付日期" size="small" prop="pay_date" label-width="80px">
                        <el-date-picker type="date" v-model="paySnForm.pay_date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="流水号" size="small" label-width="80px">
                      <el-input placeholder="请输入支付凭证流水号" v-model="getPay_sn" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="收款类型" size="small">
                      <el-select
                        v-model="paySnForm.type"
                        placeholder="请选择"
                      >
                        <el-option label="银行卡" :value="1"></el-option>
                        <el-option label="微信" :value="2"></el-option>
                        <el-option label="支付宝" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="标题" size="small" label-width="80px">
                      <el-input placeholder="请输入标题" v-model="paySnForm.title" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="付款人开户行" size="small" label-width="100px">
                      <el-input placeholder="请输入付款人开户银行" v-model="paySnForm.payee_bank_name" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="收款人开户行" size="small" label-width="100px">
                      <el-input placeholder="请输入收款人开户银行" v-model="paySnForm.account_bank_name" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="大写金额" size="small" label-width="80px">
                      <el-input placeholder="请输入大写金额" v-model="paySnForm.big_amount" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="小写金额" size="small" label-width="80px">
                      <el-input placeholder="请输入小写金额" v-model="paySnForm.small_amount" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="回单流水号" size="small" label-width="100px">
                      <el-input placeholder="请输入银行回单流水号" v-model="paySnForm.bank_receipt_sn" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="回单编号" size="small" label-width="80px">
                      <el-input placeholder="请输入回单编号" v-model="paySnForm.receipt_sn" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="摘要" size="small" label-width="80px">
                      <el-input placeholder="请输入摘要" v-model="paySnForm.bank_desc" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="用途" size="small" label-width="80px">
                      <el-input placeholder="请输入用途" v-model="paySnForm.bank_use" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="回单交易日期" size="small" prop="bank_date" label-width="110px">
                        <el-date-picker type="date" v-model="paySnForm.bank_date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="凭证方式" size="small" prop="method">
                  <el-select
                        v-model="paySnForm.method" clearable
                        placeholder="请选择凭证方式"
                      >
                        <el-option label="对公金额保费" :value="1"></el-option>
                        <el-option label="净保费" :value="2"></el-option>
                        <el-option label="佣金" :value="3"></el-option>
                        <el-option label="手续费" :value="4"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="方向" size="small" prop="flag">
                  <el-select
                        v-model="paySnForm.flag" clearable
                        placeholder="请选择方向"
                      >
                        <el-option label="上游" :value="1"></el-option>
                        <el-option label="下游" :value="2"></el-option>
                        <el-option label="平台" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
               <el-col :span="10">
                  <el-form-item label="是否退保" size="small" prop="is_cancel">
                  <el-select
                        v-model="paySnForm.is_cancel" clearable
                        placeholder="请选择是否退保"
                      >
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="退保" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="备注" size="small" prop="remark" label-width="80px">
                      <el-input placeholder="请输入备注" v-model="paySnForm.remark" autosize type="textarea"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
      </el-form>
      <el-row :gutter="24">
        <el-col :span="10" :offset="20">
          <el-button type="success" @click="paySnFormSubmit()">确认</el-button>
        </el-col>
      </el-row>

    </el-dialog>

    <el-dialog title="保单信息" :visible.sync="editDialog" width="650px">
      <el-form
              style="margin-top:20px"
              :inline="false"
              :model="payInfoForm"
              :rules="paySnRules"
              ref="paySnRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-row :gutter="24">
                <el-col :span="10">
                    <el-form-item label="投保单号" size="small" label-width="80px">
                      <el-input placeholder="请输入投保单号" v-model="payInfoForm.policy_no" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="销售价" size="small" label-width="80px">
                      <el-input placeholder="请输入销售价" v-model="payInfoForm.sell_price" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="净费" size="small" label-width="80px">
                      <el-input placeholder="请输入净费" v-model="payInfoForm.price" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="保费" size="small" label-width="80px">
                      <el-input placeholder="请输入保费" v-model="payInfoForm.real_price" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="毛利润" size="small" label-width="80px">
                      <el-input placeholder="请输入毛利润" v-model="payInfoForm.profit" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="绩效" size="small" label-width="80px">
                      <el-input placeholder="请输入绩效" v-model="payInfoForm.commission" type="text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="收款类型" size="small">
                      <el-select
                        v-model="payInfoForm.pay_type"
                        placeholder="请选择"
                      >
                        <el-option label="银行卡" :value="1"></el-option>
                        <el-option label="微信" :value="2"></el-option>
                        <el-option label="支付宝" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
      </el-form>
      <el-row :gutter="24">
        <el-col :span="10" :offset="20">
          <el-button type="success" @click="editFormSubmit()">确认</el-button>
        </el-col>
      </el-row>

    </el-dialog>

    <el-dialog title="上传保单" :visible.sync="policyDialog" width="500px">
      <el-form
              :inline="false"
              :model="policyform"
              :rules="policyrules"
              ref="policyform"
              label-width="90px"
              autocomplete="on"
            >
            <el-form-item label="上传类型" size="small">
              <el-select
                @change="uploadTypeChange"
                v-model="policyform.upload_type"
                placeholder="请选择上传类型"
              >
                <el-option label="file类型" :value="1"></el-option>
                <el-option label="url链接" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传文件" size="small" v-if="IsuploadType">
              <div>
                <el-upload
                  :on-change="policyUpload"
                  :file-list="filePolicyList"
                  accept=".pdf"
                  action=""
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="文件URL" size="small" v-if="!IsuploadType">
              <el-input clearable placeholder="请输入文件URL" v-model="policyform.upload_value" type="text"></el-input>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="reset_dialogPolicyForm('policyform')">取 消</el-button>
          <el-button type="primary" @click="policySubmitForm('policyform')">确 定</el-button>
      </div>

    </el-dialog>

    <el-dialog title="上传电子发票" :visible.sync="invoiceDialog" width="500px">
      <el-form
              :inline="false"
              :model="invoiceform"
              :rules="invoicerules"
              ref="invoiceform"
              label-width="90px"
              autocomplete="on"
            >
            <el-form-item label="上传类型" size="small">
              <el-select
                @change="invoiceTypeChange"
                v-model="invoiceform.upload_type"
                placeholder="请选择上传类型"
              >
                <el-option label="file类型" :value="1"></el-option>
                <el-option label="url链接" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传文件" size="small" v-if="IsinvoiceType">
              <div>
                <el-upload
                  :on-change="invoiceUpload"
                  :file-list="fileInvoiceList"
                  accept=".pdf"
                  action=""
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
                </el-upload>
                <!-- <el-upload
                    :on-change="invoiceUpload"
                    drag
                    :limit="1"
                    :auto-upload="false"
                    :file-list="fileInvoiceList"
                    :show-file-list="false"
                    action=""
                    accept=".pdf"
                >
                  <i class="el-icon-plus"></i>
                </el-upload> -->
              </div>
            </el-form-item>
            <el-form-item label="文件URL" size="small" v-if="!IsinvoiceType">
              <el-input clearable placeholder="请输入文件URL" v-model="invoiceform.upload_value" type="text"></el-input>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="reset_dialogInvoiceForm('invoiceform')">取 消</el-button>
          <el-button type="primary" @click="invoiceSubmitForm('invoiceform')">确 定</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换
import imgCompressUtil from "../../utils/imgCompressUtil";//压缩图片的js

export default {
  name: "orderDeal",
  components: {
    eTable
  },
  props: {},
  data() {
    return {
      // 搜索
      searchForm: {
        effective_date: '',
        corp_name: '',
        ship_name: '',
        owner_name: '',
        crmMembe_name: '',
        allPerson: '',
        product_name: '',
        corp_channel_name: '',
        plate_number: '',
        vin: '',
        status: ''
      },
      searchRules: {
        name: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
        ],
      },
      // 表头
      tableHeadConfig: [
        {
          label: "订单编号",
          columnType: "slot",
          slotName: "sn",
        },
        {
          label: "运输公司",
          columnType: "slot",
          slotName: "shopName",
        },
        {
          label: "险种",
          columnType: "slot",
          slotName: "productName",
        },
        {
          label: "订单日期",
          columnType: "slot",
          slotName: "addTime",
        },
        {
          label: "金额（元）",
          field: "price"
        },
        // {
        //   label: "操作人",
        //   columnType: "slot",
        //   slotName: "operatorame",
        // },
        // {
        //   label: "操作",
        //   columnType: "slot",
        //   slotName: "operation",
        //   width: 260
        // }
      ],
      // 数据
      page:1,// 当前页码
      limit:10,// 每页大小
      total:0,//总条目数
      id: '',

      orderData: [],

      // 所属团队 -- 员工选择 --
      teamDialog: false,
      teamTableData: [],
      teamRadio: '',  // 员工选择

      teamPage:1,// 当前页码
      teamLimit:30,// 每页大小
      teamTotal:0,//总条目数

      issuer_id: '',   //是否显示操作人，出单

      CorpData: [],
      ShipData: [],
      OwnerData: [],
      CrmMembeData: [],
      ProductData: [],

      clickPayNum: '',
      sumTotal: '',

      dialogUpload: false,
      fileUploadList:[],
      dialogImageUrl: '',

      paySnForm: {
        is_company: '',
        commission: '',
        account: '',
        account_number: '',
        payee_account: '',
        payee_account_number: '',
        pay_money: '',
        pay_date: '',
        pay_type: '',
        title: '',
        payee_bank_name: '',
        account_bank_name: '',
        big_amount: '',
        small_amount: '',
        bank_receipt_sn: '',
        receipt_sn: '',
        bank_desc: '',
        bank_use: '',
        bank_date: '',
        method: '',
        flag: '',
        is_cancel: '',
        remark: ''
      },
      order_info_product_ids: [],
      getPay_sn: '',
      payInfoForm: {
        policy_no: '',
        sell_price: '',
        price: '',
        real_price: '',
        profit: '',
        commission: '',
        type: ''
      },

      //险种方案的验证
      paySnRules: {
        is_company: [
          { required: true, message: "请选择是否对公", trigger: "change" },
        ],
        method: [
          { required: true, message: "请选择凭证方式", trigger: "change" },
        ],
        flag: [
          { required: true, message: "请选择方向", trigger: "change" },
        ],
        is_cancel: [
          { required: true, message: "请选择是否退保", trigger: "change" },
        ],
        // effective_date: [
        //   { required: true, message: "请先选择生效日期", trigger: "blur" },
        // ],
      },

      editDialog: false,

       // ------ 上传保单 -------
       policyDialog: false,
      IsuploadType: true,
      filePolicyList: [],
      policyform: {
        upload_type: 1,
        buyBankAccount: '',
        buyPhoneNo: '',
        buyBankName: '',
        buyInvType: '',
        order_id: ''
      },
      policyrules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],
      },
      policyDriving: '',

       // 上传电子发票
      invoiceDialog: false,
      IsinvoiceType: true,
      fileInvoiceList: [],
      invoiceform: {
        upload_type: 1,
        buyBankAccount: '',
        buyPhoneNo: '',
        buyBankName: '',
        buyInvType: '',
        order_id: ''
      },
      invoicerules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],
      },
      invoiceDriving: '',

    };
  },
  created() {
    this.DataList()
    this.CorpList()
    this.ShipCompanyList()
    this.OwnerList()
    this.CrmMembeList()
    this.ProductList()
    this.GetPaySN()
  },
  mounted() {},
    filters: {
    /**
     * @param {
     *
     * }
     */
    statusFilter(status) {
      if (status == 0) {
        return "待审核";
      } else if (status == 1) {
        return "已审核";
      } else if (status == 2) {
        return "已出单";
      } else if (status == 3) {
        return "已完成";
      } else if (status == 4) {
        return "取保";
      } else if (status == 5) {
        return "退单";
      }
    },
    sexFilter(sex) {
      if (sex == 0) {
        return "女";
      } else if (sex == 1) {
        return "男";
      }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {

    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      // var h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      // var mi = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      // var s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
      return y + '-' + m + '-' + d
    },
    // 获取页面的 getPay_sn
    GetPaySN() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getPaySN(param).then(res => {
        if(res.code == 200){
          this.getPay_sn = res.data.pay_sn
          //console.log(res,333);
        }
      }).catch(function (error) {
        //console.log(error);
      })
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize: this.limit,
      }
      this.$axios.shopOrderDeal(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data);
          this.orderData = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 获取当前选择保险公司的值
    changeCorpValue(e){
      //console.log(e);
      this.searchForm.corpName = e
    },
    CorpList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.insuranceCorpNoList(param).then(res=>{
        if(res.code == 200){
          this.CorpData = res.data
          this.searchForm.corp_name = res.data.name
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 获取当前选择投保人的值
    changeShipCompanyValue(e){
      //console.log(e);
      this.searchForm.ship_name = e
    },
    ShipCompanyList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.shipCompanyNoPage(param).then(res=>{
        if(res.code == 200){
          this.ShipData = res.data
          this.searchForm.ship_name = res.data.name
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 获取当前选择被投保人的值
    changeOwnerValue(e){
      //console.log(e);
      this.searchForm.owner_name = e
    },
    OwnerList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.OwnerNoPage(param).then(res=>{
        if(res.code == 200){
          this.OwnerData = res.data
          this.searchForm.owner_name = res.data.name
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 获取当前选择业务渠道的值
    changeCrmMembeValue(e){
      //console.log(e);
      this.searchForm.crmMembe_name = e
    },
    CrmMembeList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.crmMembeListNoPage(param).then(res=>{
        if(res.code == 200){
          this.CrmMembeData = res.data
          this.searchForm.crmMembe_name = res.data.name
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 获取当前选择业务渠道的值
    changeProductValue(e){
      //console.log(e);
      this.searchForm.product_name = e
    },
    ProductList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.insuranceProductlList(param).then(res=>{
        if(res.code == 200){
          let arrData = []
          res.data.data.forEach(v => {
            arrData.push(v)
          });
          this.ProductData = arrData
          this.searchForm.product_name = res.data.name
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    searchSubmit() {
      if(this.searchForm.effective_date == ''){
          this.searchForm.effective_date = ''
        }else{
          this.searchForm.effective_date == this.getTime(this.searchForm.effective_date)
      }
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        plate_number: this.searchForm.plate_number,
        effective_date: this.searchForm.effective_date,
        corp_name: this.searchForm.corp_name,
        owner_name: this.searchForm.ship_name,
        allPerson: this.searchForm.allPerson,
        product_name: this.searchForm.product_name,
        corp_channel_name: this.searchForm.corp_channel_name,
        vin: this.searchForm.vin,
        status: this.searchForm.status,
      }
      //console.log(param,777);
      this.$refs.searchForRef.validate((valid) => {
        if (valid) {
          this.$axios.issuerOrderList(param).then(res=>{
            if(res.code == 200){
              this.orderData = res.data.data
              this.total = res.data.total
            }
          }).catch(error =>{
              //console.log(error);
          })
        }
      })
    },

    // 禁止选择已有的支付凭证转款截图
    selectable(row,index){
      return row.pay_id <= 0//为true的时候可以选，为false则不可选择
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //console.log(val,2222);
      this.clickPayNum = val.length
      // 计算选择的订单的金额
      let sum = 0;
      val.forEach((item)=> {
        sum += parseFloat(item.price);
      });
      this.sumTotal = sum
      // 获取当前点击的ids的值
      let ids = []
      val.forEach(v => {
        ids.push(v.id)
      });
      this.order_info_product_ids = ids
      //console.log(this.order_info_product_ids,3332);
    },
    resetPayInfoSubmit() {
      this.dialogUpload = false
      // this.$refs[formName].resetFields();
    },
     // 指定分配订单
     handelAppointUser(e){
        //console.log(e.id);
        this.id = e.order_id  // 订单号
        this.teamDialog = true
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.teamPage,
          pageSize: this.teamLimit,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            // 获取检索部门人员
            // let arrData = []
            // res.data.data.forEach(value => {
            //   if(value.department.name == '渠道部'){
            //     arrData.push(value)
            //   }
            // });
            this.teamTableData = res.data.data
            this.teamTotal = res.data.total
          }
        }).catch(error=>{
          //console.log(error);
        })
    },
      // 设置每页条数
    teamSizeChange(newSize) {
      this.teamLimit = newSize
      this.team()
    },
    // 分页跳转
    teamCurrentChange(newPage) {
      this.teamPage = newPage
      this.team()
    },
    // -------------- 指定分配人 ---------------
    getTeamRow(e) {
        this.$confirm('此操作将分配该订单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          operate_id: sessionStorage.getItem('user_id'),    // 操作人ID
          issuer_id: e.id,    // 出单人ID
          order_id: this.id          // 订单号
        }
        this.$axios.OrderInfoAppointUser(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          // 点击取消:不删除了
          this.$message({
              type: 'info',
              message: '已取消分配'
          });
          this.DataList()
      });
      this.teamDialog = false
    },
    headStyle(){
        return "text-align:center"
    },

    clickDialog(){
      // 判断当前订单处理id是否存在
      if(this.multipleSelection != undefined  ){
        this.dialogUpload = true
      }else{
        this.$message.error('请先选择要处理的订单');
      }
    },
     // ========财务票据-识别银行回单信息==================================
    // 支付凭证封面上传
    //上传图片的方法
    UploadImage(file,filelist) {
      //console.log(file);
      this.bankReceiptImages = file.raw
      this.UploadImageimgCompress(file.raw)

      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('file_type', 5)
      payFd.append('file_value', this.getPay_sn)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      //console.log(payFd,333);
      this.$axios.ossUploadFile(payFd).then(res=>{
        //console.log(res);
        if(res.code == 200){
          this.dialogImageUrl = res.data.src
          // 财务票据，识别通用
          //console.log(file,9938934);
        }
      })
      .catch(error => console.log(error))
    },
    //图片压缩方法
    async UploadImageimgCompress(file) {
      await imgCompressUtil.compressImg(file).then((res) => {
        this.ocrVehiceBank(res); //调用获取access_token方法并将压缩好的图片base64格式传递过去
      });
    },

    ocrVehiceBank(data) {
      const param = {
        image: data,
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.ocrBankReceiptNew(param).then(res => {
        if(res.code == 200){
          this.paySnForm = res.data.res
          this.$message.success(res.msg+'点击此图片可查看明细')
        }
        //console.log(res,33333333);
      }).catch(function (error) {
        //console.log(error);
      })
    },
    // 合并订单支付
    paySnFormSubmit() {
      this.$refs.paySnRef.validate((valid) => {
        if (valid) {
          //console.log(this.order_info_product_ids);
          const param = {
            is_company: this.paySnForm.is_company,
            commission: this.paySnForm.commission,
            account: this.paySnForm.account,
            account_number: this.paySnForm.account_number,
            payee_account: this.paySnForm.payee_account,
            payee_account_number: this.paySnForm.payee_account_number,
            pay_money: this.paySnForm.pay_money,
            pay_date: this.paySnForm.pay_date,
            pay_sn: this.getPay_sn,
            type: this.paySnForm.type,
            title: this.paySnForm.title,
            payee_bank_name: this.paySnForm.payee_bank_name,
            account_bank_name: this.paySnForm.account_bank_name,
            big_amount: this.paySnForm.big_amount,
            small_amount: this.paySnForm.small_amount,
            bank_receipt_sn: this.paySnForm.bank_receipt_sn,
            receipt_sn: this.paySnForm.receipt_sn,
            bank_desc: this.paySnForm.bank_desc,
            bank_use: this.paySnForm.bank_use,
            bank_date: this.paySnForm.bank_date,
            method: this.paySnForm.method,
            flag: this.paySnForm.flag,
            is_cancel: this.paySnForm.is_cancel,
            remark: this.paySnForm.remark,
            order_info_product_ids: this.order_info_product_ids,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token')
          }
          //console.log(param,333);
          this.$axios.payMergePay(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
              this.dialogUpload = false
            }else if(res.code == 1){
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }
      })
    },
    handelEdit(index,row) {
      //console.log(index,11);
      this.id = index.id
      this.title = '编辑'
      this.editDialog = true
      // this.form = {...row};
      // 或者
      this.payInfoForm = JSON.parse(JSON.stringify(index))
    },
    // 修改该保单信息
    editFormSubmit() {
      this.$refs.paySnRef.validate((valid) => {
        if (valid) {
          const param = {
            order_info_product_id: this.payInfoForm.order_info_product_id,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            operator_name: this.payInfoForm.operator_name,
            goods_list: {
              pay_id: this.payInfoForm.pay_id,
              corp_id: this.payInfoForm.corp_id,
              product_md_id: this.payInfoForm.product_md_id,
              product_id: this.payInfoForm.product_id,
              corp_channel_id: this.payInfoForm.corp_channel_id,
              policy_no: this.payInfoForm.policy_no,
              sell_price: this.payInfoForm.sell_price,
              price: this.payInfoForm.price,
              real_price: this.payInfoForm.real_price,
              profit: this.payInfoForm.profit,
              commission: this.payInfoForm.commission,
              type: this.payInfoForm.pay_type
            }
          }
          //console.log(param,333);
          this.$axios.payProductEdit(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
              this.editDialog = false
            }else if(res.code == 1){
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }
      })
    },

       // ===== ----电子非见费承保 -- 是否出单 ----- ==========
       handelUnderwritel(e) {
        //console.log(e);
        this.$confirm('此操作将是否出单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          order_id: e.order_id,
        }
        this.$axios.IsUnderwrite(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          this.$message({
              type: 'info',
              message: '已取消出单'
          });
          this.DataList()
      });
    },
    // ===== -----上传保单 ----- ==========
    handelUploadPolicy(e) {
      //console.log(e);
      this.policyform.order_id = e.order_id
      this.policyDialog = true
    },
    reset_dialogPolicyForm(formName) {
      this.policyDialog = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    // 判断上传的类型展示
    uploadTypeChange(e) {
      //console.log(e,887);
      if(e == 2) {
        this.IsuploadType = false
      }else{
        this.IsuploadType = true
      }
    },
    // 上传文件 保单
    policyUpload(file, fileLists) {
        this.policyDriving = file.raw
		},
    policySubmitForm(formName) {
      //console.log(22);
      this.$refs[formName].validate((valid) => {
        if (valid) {
            let policyFd = new FormData()
            policyFd.append('order_id', this.policyform.order_id)
            policyFd.append('file', this.policyDriving)
            policyFd.append('file_type', 4)
            policyFd.append('upload_type', this.policyform.upload_type)
            policyFd.append('upload_value', this.policyform.upload_value)
            policyFd.append('company_id', sessionStorage.getItem('company_id'))
            policyFd.append('access_token', sessionStorage.getItem('token'))
            this.$axios.guorenFileUpload(policyFd).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.policyDialog = false
                }else{
                    this.$message.error(res.msg);
                }
            })
          }
        })
    },

     // ===== ----- 上传电子发票 ----- ==========
     handelUploadinvoice(e) {
      //console.log(e);
      this.invoiceform.order_id = e.order_id
      this.invoiceDialog = true
    },
    reset_dialogInvoiceForm(formName) {
      this.invoiceDialog = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    // 判断上传的类型展示
    invoiceTypeChange(e) {
      //console.log(e,887);
      if(e == 2) {
        this.IsinvoiceType = false
      }else{
        this.IsinvoiceType = true
      }
    },
    // 上传文件 电子发票
    invoiceUpload(file, fileLists) {
        this.invoiceDriving = file.raw
        //console.log(this.invoiceDriving,1111);
		},
    invoiceSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            let invoiceFd = new FormData()
            invoiceFd.append('order_id', this.policyform.order_id)
            invoiceFd.append('file', this.invoiceDriving)
            invoiceFd.append('file_type', 7)
            invoiceFd.append('upload_type', this.policyform.upload_type)
            invoiceFd.append('upload_value', this.policyform.upload_value)
            invoiceFd.append('company_id', sessionStorage.getItem('company_id'))
            invoiceFd.append('access_token', sessionStorage.getItem('token'))
            this.$axios.guorenFileUpload(invoiceFd).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.invoiceDialog = false
                }else{
                    this.$message.error(res.msg);
                }
            })
          }
        })
    },

  },
};
</script>
<style lang="less">
  .table_name{
    font-weight: bold;
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .pay_title{
    width: 600px;
    /* border: 1px solid #f00; */
    position: absolute;
    top: 15px;
    left: 100px;
  }
  .pay_nei_table{
    height: 500px;
    overflow: auto;
  }
  .keyButton.el-button{
    width: 100%;
    overflow:hidden;
    text-align: left;
    text-overflow:ellipsis;
    white-space:nowrap;
    border: 0 !important;
    background: transparent;
    padding: 0 !important;
  }
  .keyButton.el-button:hover{
      border: 0 !important;
      background: transparent;
      padding: 0 !important;

  }

</style>



// WEBPACK FOOTER //
// src/view/shipCompany/shopOrderDeal.vue